import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Navbar/Navbar.jsx";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import baseURL from "../../config.js";
import { Zoom } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { FaEdit } from "react-icons/fa";
import {
  Table,
  Checkbox,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Pagination,
  Box,
  Typography,
  Modal,
  Autocomplete,
  Chip,
} from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import ExpiryDate from "../../utils/ExpiryDate.jsx";
import ExpiringShipDetails from "./getExpiryDatedvessels.jsx";

const VesselTable = () => {
  const [shipDetails, setShipDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openAssignModal, setOpenAssignModal] = useState(false);
  const [OpenExpiringVessels, setOpenExpiringVessels] = useState(false)
  const [shipDetailsWithoutPagination, setShipDetailsWithoutPagination] = useState([]);
  const [crewingAgents, setCrewingAgents] = useState([]);
  const [selectedCrewingAgent, setSelectedCrewingAgent] = useState(null);
  const [selectedVessels, setSelectedVessels] = useState([]);
  const [selectedShip, setSelectedShip] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [totalVessel, setTotalVessel] = useState(0)
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const itemsPerPage = 10;
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchShipDetails = async () => {
  //     try {
  //       const response = await axios.get(`${baseURL}/api/vesselform`);
  //       setShipDetails(response.data);
  //     } catch (error) {
  //       console.error("Error fetching ship details:", error);
  //     }
  //   };
  //   fetchShipDetails();
  // }, []);
  // Fetch ship details when modal opens
  useEffect(() => {
    if (openAssignModal) {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const fetchShipDetails = axios.get(`${baseURL}/api/getvesselwithoutpagination`, { headers });
      const fetchCrewingAgents = axios.get(`${baseURL}/api/getcrewingAgentDetails`, { headers });

      Promise.all([fetchShipDetails, fetchCrewingAgents])
        .then(([shipRes, agentRes]) => {
          setShipDetailsWithoutPagination(shipRes.data.data);
          setCrewingAgents(agentRes.data);
        })
        .catch((error) => {
          console.error("Error fetching data for assign modal:", error);
        });
    }
  }, [openAssignModal]);




  // Handle vessel selection
  const handleVesselChange = (event, value) => {
    setSelectedVessels(value);
  };

  // Handle crewing agent selection
  const handleCrewingAgentChange = (event, value) => {
    setSelectedCrewingAgent(value);

  };

  // Handle Submit
  const handleSubmit = async () => {
    if (!selectedCrewingAgent || selectedVessels.length === 0) {
      alert("Please select at least one vessel and one crewing agent.");
      return;
    }

    const vesselIds = selectedVessels.map(vessel => vessel._id);
    const crewingAgentId = selectedCrewingAgent._id;

    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${baseURL}/api/vesselAgent`, {
        vesselIds,
        crewingAgentId
      },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

      toast.success(response.data.message);
      setOpenAssignModal(false);
    } catch (error) {
      console.error("Error assigning vessels:", error);
      toast.error(error.response.data.message, { type: "error" });
    }
  };

  useEffect(() => {
    const fetchShipDetails = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${baseURL}/api/getvesselform`, {
          params: {
            page: currentPage,
            limit: itemsPerPage,
            search: searchTerm, // Pass search term to backend
          },
          headers: { Authorization: `Bearer ${token}` },
        });
        setShipDetails(response.data.data); // Set the ship details from API response
        setTotalPages(response.data.totalPages); // Update total pages for pagination
        setTotalVessel(response.data.total)
      } catch (error) {
        console.error("Error fetching ship details:", error);
        setError(error?.response?.data?.message);
      }
    };
    fetchShipDetails();
  }, [currentPage, searchTerm]); // Fetch data when page or search term changes


  // const handleOpenModal = (documents) => {
  //   setSelectedDocuments(documents);
  //   setOpenModal(true);
  // };
  // const handleOpenModal = (ship) => {
  //  
  //   if (ship) {
  //     const documents = Object.entries(ship)
  //       .filter(([key, doc]) =>
  //         ["seagreement", "cdagreement", "pipolicydocument", "maritimelabourconvention", "fsdocument", "dmlcp1", "dmlc2"].includes(key) &&
  //         doc && (doc.filePath || doc.originalName) // Ensure doc exists and has a valid property
  //       )
  //       .map(([key, doc]) => ({
  //         fileName: doc.originalName || key,  // Use original name if available
  //         filePath: doc.filePath ? `${baseURL}/${doc.filePath.replace(/\\/g, "/")}` : null, // Fix backslashes
  //       }));

  //     setSelectedDocuments(documents);
  //   } else {
  //     setSelectedDocuments([]);
  //   }
  //   setOpenModal(true);
  // };

  const handleOpenModal = (ship) => {
    if (ship) {
      const displayNames = {
        pipolicydocument: "P&I Certificate",
        maritimelabourconvention: "Maritime Labour Convention",
        fsdocument: "Financial Security Document",
        dmlcp1: "DMLC Part 1",
        dmlc2: "DMLC Part 2",
      };

      const documents = Object.entries(ship)
        .filter(([key, value]) =>
          Object.keys(displayNames).includes(key) && value
        )
        .map(([key, value]) => {
          let filePath = typeof value === "string" ? value : value?.filePath;

          if (!filePath) return null;

          filePath = filePath.replace(/\\/g, "/");

          if (!filePath.startsWith("http")) {
            if (filePath.startsWith("/Documents")) {
              filePath = `${backendBaseURL}${filePath}`;
            } else {
              filePath = `${baseURL}/${filePath}`;
            }
          }

          return {
            name: displayNames[key],     // Friendly name
            fileName: key,               // Original key
            filePath: filePath,
          };
        })
        .filter(Boolean);

      setSelectedDocuments(documents);
      setOpenModal(true);
    }
  };



  return (
    <>
      <Navbar />
      {/* Error message */}
          {error && (
            <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
              <Typography color="error" variant="h6">
                {error}
              </Typography>
            </Box>
          )}

      <div style={{ padding: "20px" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2, marginBottom: "10px" }}>
          {/* Search Box on Left */}
          <TextField
            label="Search by Vessel Name or IMO Number"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ maxWidth: 300, backgroundColor: "#f5f5f5" }}
          />
          <Button variant="contained"  sx={{backgroundColor:"#C30B12"}} onClick={() => navigate("/expiring-vessels")}>
            Expiring Vessels
          </Button>

          {/* Table Name in Center with Ship Icon */}
          <Box sx={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "center" }}>
            <Typography variant="h5" gutterBottom sx={{ color: "#C30B12", display: "flex", alignItems: "center" }}>
              <DirectionsBoatIcon sx={{ color: "#C30B12", marginRight: "8px" }} />
              Vessel Table
            </Typography>
          </Box>

          {/* Buttons on Right */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button variant="contained" onClick={() => setOpenAssignModal(true)} sx={{ backgroundColor: "#C30B12"}} >
              Assigned Vessel to Crewing Agent
            </Button>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, padding: "6px 12px", bgcolor: "#fff3cd", borderRadius: "8px" }}>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#856404" }}>
                Total Vessels:
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#d39e00" }}>
                {totalVessel}
              </Typography>
            </Box>


          </Box>
        </Box>

        {/* Expiring Vessels Modal */}
        <Modal open={OpenExpiringVessels} onClose={() => setOpenExpiringVessels(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              maxWidth: 800,
              bgcolor: "white",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <ExpiringShipDetails />
            <Box display="flex" justifyContent="center" mt={2}>
              <Button variant="contained" color="error" onClick={() => setOpenExpiringVessels(false)}>
                Close
              </Button>
            </Box>
          </Box>
        </Modal>


        <TableContainer component={Paper} style={{ marginTop: "20px", overflow: "hidden" }}>
          <Table sx={{ '& td': { verticalAlign: 'unset' } }}>
            <TableHead sx={{ backgroundColor: "#C30B12", height: "30px" }}>
              <TableRow>
                <TableCell sx={{ width: "100px", color: "white", fontWeight: "bold" }}>
                  Sr. No.
                </TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Ship Information</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Insurance Details</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Certificates</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Documents</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shipDetails.map((ship, index) => (
                <TableRow key={index}>
                  <TableCell>{(currentPage - 1) * itemsPerPage + index + 1}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1">
                        <span
                          style={{
                            backgroundColor: "#b8860b", // Light blue
                            color: "#FFFFFF", // Black text for better contrast
                            padding: "4px 8px",
                            borderRadius: "5px",
                          }}
                        >
                          <strong>Vessel Owner:</strong> {ship?.company_name?.company_shortname}
                        </span>
                      </Typography>


                      <Typography
                        variant="body1">
                        <span
                          style={{
                            backgroundColor: "gold", // Light blue
                            color: "black", // Black text for better contrast
                            padding: "4px 8px",
                            borderRadius: "5px",
                          }}
                        >
                          <strong>Vessel Name:</strong> {ship.vesselname}
                        </span>

                      </Typography>

                      <Typography variant="body1"><strong>IMO Number: </strong>{ship.IMO_Number}</Typography>
                      <Typography variant="body1"><strong>Ship Type: </strong>{ship.vesseltype}</Typography>
                      <Typography variant="body1"><strong>Ship Flag: </strong>{ship.Flag}</Typography>
                      <Typography variant="body1"><strong>Gross Tonage: </strong>{ship.gross_tonage}</Typography>
                      <Typography variant="body1"><strong> KiloWatt: </strong>{ship.kiloWatt || "-"}</Typography>
                      <Typography variant="body1"><strong> BHP: </strong>{ship.bhp || "-"}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>P&I Number:</strong> {ship.pipolicynumber}</Typography>
                      <ExpiryDate label="policy date validity" date={ship.policydateofv} />
                      <Typography variant="body1"><strong>Financial Security Number:</strong> {ship.fsdnumber}</Typography>
                      <ExpiryDate label="Financial Security Validity" date={ship.fsdvalidity} />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>MLC Cert No.:</strong> {ship.mlcCert}</Typography>
                      <Typography variant="body1"><strong>MLC Iss. Date:</strong> {new Date(ship.mlcIssueDate).toLocaleDateString("en-GB")}</Typography>
                      <ExpiryDate label="MLC Exp. Date" date={ship.mlcExpiryDate} />
                      {ship.dmlcCert1 && (<Typography variant="body1"><strong>DMLC 1:</strong> {ship.dmlcCert1}</Typography>)}
                      {ship.dmlcCert2 && (<Typography variant="body1"><strong>DMLC 2:</strong> {ship.dmlcCert2}</Typography>)}
                      
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleOpenModal(ship)}>
                      <PictureAsPdfIcon sx={{ color: "red" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "60%", md: "50%" },
            maxHeight: "80vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
          >
            Vessel Documents
          </Typography>
          {selectedDocuments.length > 0 ? (
            selectedDocuments
              .map(doc => ({
                ...doc,
                filePath: doc.filePath.includes("/Documents/")
                  ? doc.filePath
                  : doc.filePath.replace("/vesselupload/", "/Documents/vesselupload/")
              }))
              .map((doc, index) => (
                <Paper
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                    mb: 2,
                    boxShadow: 2,
                    borderRadius: 2,
                    transition: "0.3s",
                    "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                    <Typography variant="body1">
                      {doc.name ? doc.name : "Unknown Document"}
                    </Typography>

                  </Box>

                  {/* Check if filePath exists and is valid */}
                  {doc.filePath && doc.filePath.trim() !== "" ? (
                    <Button
                      variant="contained"
                   
                      href={doc.filePath}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="small"
                      sx={{ textTransform: "none" , backgroundColor: "#b8860b"}}
                    >
                      Download
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No File Available
                    </Typography>
                  )}
                </Paper>
              ))
          ) : (
            <Typography align="center" color="textSecondary">
              No documents available
            </Typography>
          )}




          <Box display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="error" onClick={() => setOpenModal(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>


      <Modal open={openAssignModal} onClose={() => setOpenAssignModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            bgcolor: "rgba(255, 255, 255, 0.9)", // Glassmorphism effect
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
            backdropFilter: "blur(10px)", // Blurred background
            p: 4,
            borderRadius: 3,
            outline: "none",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          {/* Header with Close Button */}
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" fontWeight={700} sx={{color:"#C30B12"}}>
              🚢 Assign Vessel
            </Typography>
            <IconButton onClick={() => setOpenAssignModal(false)} sx={{ color: "#666" }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Vessel Selection */}
          <Autocomplete
            multiple
            options={shipDetailsWithoutPagination}
            getOptionLabel={(option) => `${option.vesselname} (${option.company_name?.company_shortname || "N/A"})`}
            isOptionEqualToValue={(option, value) => option._id === value?._id}
            value={selectedVessels}
            onChange={handleVesselChange}
            disableCloseOnSelect
            renderOption={(props, option, { selected }) => (
              <li
                {...props}
                style={{
                  display: "flex",
                  alignItems: "center",
                  minHeight: 45,
                  padding: "10px 14px",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                  borderRadius: "8px",
                  transition: "background 0.3s",
                  background: selected ? "#e3f2fd" : "transparent",
                }}
              >
                <Checkbox checked={selected} sx={{ mr: 1, p: 0 }} disableRipple />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: "14px", fontWeight: selected ? "600" : "400" }}>
                    {option.vesselname}
                  </span>
                  <span style={{ fontSize: "12px", color: "#666" }}>
                    {option.company_name?.company_shortname || "N/A"}
                  </span>
                </div>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Vessels"
                required
                sx={{
                  mt: 2,
                  background: "white",
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": { "& fieldset": { border: "none" } },
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                }}
              />
            )}
          />


          {/* Crewing Agent Selection */}
          <Autocomplete
            options={crewingAgents}
            getOptionLabel={(option) => option.agentName || ""}
            isOptionEqualToValue={(option, value) => option._id === value?._id}
            onChange={handleCrewingAgentChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Crewing Agent"
                required
                sx={{
                  mt: 2,
                  background: "white",
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": { "& fieldset": { border: "none" } },
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                }}
              />
            )}
          />

          {/* Action Buttons */}
          <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
            <Button
              variant="contained"
              
              onClick={handleSubmit}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
                px: 3,
                py: 1.2,
                backgroundColor: "gold",
                color:"black"
              }}
            >
              ✅ Assign
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => setOpenAssignModal(false)}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
                px: 3,
                py: 1.2,
              }}
            >
              ❌ Close
            </Button>
          </Box>
        </Box>
      </Modal>


      <Box display="flex" justifyContent="center" mt={3}>

        {/* Pagination */}
        <Box mt={4} display="flex" justifyContent="center">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(event, page) => setCurrentPage(page)} // Correctly update state
            variant="outlined"
            shape="rounded"
          />

        </Box>
      </Box>


      <ToastContainer />
    </>
  );
};

export default VesselTable;
